import React from 'react';

export default function AccountGridBox({ label, value }) {
	return (
		<div>
			<div className="fs-4 font-medium text-black">{label}</div>
			<div className="fs-5 font-small text-black">{value}</div>
		</div>
	);
}
